import { CellFieldV2 as CellField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface SummaryTabProps {
  tongTienNt?: number;
  tongTienNt2?: number;
  tongChietKhau?: number;
  formMode?: FormMode;
}

export default function SummaryTab({ tongTienNt = 0, tongTienNt2 = 0, tongChietKhau = 0, formMode }: SummaryTabProps) {
  const isViewMode = formMode === 'view';

  return (
    <div className='grid w-96 grid-cols-1 gap-y-2 p-4'>
      <div className='flex items-center gap-4'>
        <Label className='w-32 font-semibold'>Tổng tiền vốn</Label>
        <CellField
          className='border-b'
          name='t_tien_nt'
          type='number'
          value={Number(tongTienNt)}
          disabled={isViewMode}
        />
        <CellField className='hidden border-b' name='t_tien' type='number' disabled={isViewMode} />
      </div>
      <div className='flex items-center gap-4'>
        <Label className='w-32 font-semibold'>Tổng chiết khấu</Label>
        <CellField
          className='border-b'
          name='t_ck_nt'
          type='number'
          value={Number(tongChietKhau)}
          disabled={isViewMode}
        />
        <CellField className='hidden border-b' name='t_ck' type='number' disabled={isViewMode} />
      </div>
      <div className='flex items-center gap-4'>
        <Label className='w-32 font-semibold'>Tổng tiền hàng</Label>
        <CellField
          className='border-b'
          name='t_tc_tien_nt2'
          type='number'
          value={Number(tongTienNt2)}
          disabled={isViewMode}
        />
        <CellField className='hidden border-b' name='t_tc_tien' type='number' disabled={isViewMode} />
      </div>
      <div className='flex items-center gap-4'>
        <Label className='w-32 font-semibold'>Tổng tiền KM</Label>
        <CellField className='border-b' name='t_km_nt' type='number' value={0} disabled={isViewMode} />
        <CellField className='hidden border-b' name='t_km' type='number' disabled={isViewMode} />
      </div>
    </div>
  );
}
